import PageSeo from '../seo/PageSeo';
import { useInitialData } from '../seo/InitialData';
import React, { useMemo, useContext } from 'react'
import { Link, useParams } from 'react-router-dom'
import ImageGallery from '../components/PhotoGallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import ReactMarkdown from 'react-markdown';

import { AppContext } from "../App";
import { sortBy, useArchive } from '../api/archive';
import BlogListsBlog from '../components/BlogListsBlog';
import {
  getBlogGalleryItems,
  getBlogHeroImageUrl,
  getBlogPublishedLabel,
  getBlogSummary,
} from './blogItemUtils';

export default function BlogItem() {
  const initial = useInitialData();
  const strapiURL = useContext(AppContext)
  const { id } = useParams();
  const { archive, error: archiveError } = useArchive();
  const item = initial.item?.documentId === id ? initial.item : archive?.blogs.find((entry) => entry.documentId === id) || null;
  const itemBlogsList = archive ? sortBy(archive.blogs, 'createdAt', 'DESC').slice(0, 5) : initial.blogs || [];
  const isLoading = !item && !archive && !archiveError;
  const hasError = Boolean(archiveError && !item);

  const galleryItems = useMemo(() => getBlogGalleryItems(item || {}, strapiURL), [item, strapiURL]);
  const heroImageUrl = getBlogHeroImageUrl(item || {}, strapiURL);

  if (isLoading) {
    return (
      <section className="retro-blog-page">
      <PageSeo item={item} unavailable={hasError || isLoading} />
        <div className="retro-blog-inner">
          <div className="retro-item-empty">Ładowanie wpisu...</div>
        </div>
      </section>
    );
  }

  if (hasError || !item) {
    return (
      <section className="retro-blog-page">
      <PageSeo item={item} unavailable={hasError || isLoading} />
        <div className="retro-blog-inner">
          <Link to="/" className="retro-back-link">
            <i className="feather-chevron-left" aria-hidden="true"></i>
            Wróć do archiwum
          </Link>
          <div className="retro-item-empty">Nie udało się pobrać wpisu.</div>
        </div>
      </section>
    );
  }

  return (
    <section className="retro-blog-page">
      <PageSeo item={item} unavailable={hasError || isLoading} />
      <div className="retro-blog-inner">
        <Link to="/" className="retro-back-link">
          <i className="feather-chevron-left" aria-hidden="true"></i>
          Wróć do archiwum
        </Link>

        <article className="retro-blog-hero">
          <div className="retro-blog-copy">
            <span className="retro-blog-date">{getBlogPublishedLabel(item)}</span>
            <h1>{item.Title}</h1>
            <p>{getBlogSummary(item)}</p>
          </div>

          <div className="retro-blog-media">
            {heroImageUrl ? (
              <img src={heroImageUrl} alt={item.Title} />
            ) : (
              <div className="retro-item-media-fallback">NO IMAGE</div>
            )}
          </div>
        </article>

        <div className="retro-blog-layout">
          <div className="retro-blog-main">
            {galleryItems.length > 0 && (
              <section className="retro-blog-section">
                <div className="retro-item-section-header">
                  <h2>Galeria</h2>
                  <p>{galleryItems.length} plików</p>
                </div>
                <div className="retro-gallery-frame">
                  <ImageGallery
                    items={galleryItems}
                    showFullscreenButton={true}
                    showPlayButton={true}
                    autoPlay={false}
                    slideInterval={6000}
                    slideDuration={450}
                    showBullets={true}
                    showThumbnails={true}
                    showIndex={true}
                    infinite={true}
                    showNav={true}
                    thumbnailPosition="top"
                    useBrowserFullscreen={true}
                    useWindowKeyDown={true}
                  />
                </div>
              </section>
            )}

            <section className="retro-blog-section">
              <div className="retro-item-section-header">
                <h2>Wpis</h2>
                <p>Archiwum</p>
              </div>
              <div className="retro-blog-body">
                <ReactMarkdown>{item.Body || 'Ten wpis czeka na uzupełnienie.'}</ReactMarkdown>
              </div>
            </section>
          </div>

          <aside className="retro-blog-sidebar">
            <div className="retro-item-sidebar-card">
              <h2>Inne wpisy</h2>
              <BlogListsBlog bloglistsblog={itemBlogsList} currentId={item.documentId} />
            </div>
          </aside>
        </div>
      </div>
    </section>
  )
}
